/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { DatasetShape, NgGenericTask } from '@karya/core';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export type GenerateSpecRequest = {
  user_prompt: string;
  dataset_shape?: DatasetShape;
  main_spec?: NgGenericTask;
  current_spec?: NgGenericTask;
};

export type GenerateSpecResponse = {
  spec: NgGenericTask;
};

export const genAI = createApi({
  reducerPath: 'genAI',

  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_AI_API_URL }),

  endpoints: (builder) => ({
    generateSpec: builder.mutation<GenerateSpecResponse, GenerateSpecRequest>({
      query: (data) => ({
        url: '/spec/generate',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});
